var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage3D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 25.9974C32 26.5041 31.72 26.9441 31.2933 27.1707L20.76 33.0907C20.5467 33.2507 20.28 33.3307 20 33.3307C19.72 33.3307 19.4533 33.2507 19.24 33.0907L8.70667 27.1707C8.49291 27.0584 8.31402 26.8896 8.18944 26.6828C8.06485 26.4759 7.99933 26.2389 8.00001 25.9974V13.9974C8.00001 13.4907 8.28001 13.0507 8.70667 12.8241L19.24 6.90406C19.4533 6.74406 19.72 6.66406 20 6.66406C20.28 6.66406 20.5467 6.74406 20.76 6.90406L31.2933 12.8241C31.72 13.0507 32 13.4907 32 13.9974V25.9974ZM20 9.53073L12.0533 13.9974L20 18.4641L27.9467 13.9974L20 9.53073Z",
    fill: "#9BA1A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage3D);
export default __webpack_public_path__ + "static/media/image_3D.eb3ad6d3b31b0b07ac7b8896b31b9bfe.svg";
export { ForwardRef as ReactComponent };